import React, { useContext, useRef, useState } from "react";
import { helperText, uploadFile } from "../Helper/helperFunctions";
import CommonContext from "../Context/context";
import ReactHtmlParser from "react-html-parser";

import { postRecruitment } from "../Service/ApiFunction";
import { toast } from "react-toastify";
const emptyData = {
  contactNo: "",
  email: "",
  highestQualification: "",
  postApplied: "",
  file: " ",
  fullName: "",
};
const Recruitment = () => {
  const recruitmentRef = useRef();
  const { cmsData } = useContext(CommonContext);
  const RecruitmentAbout = cmsData?.find(
    (ele) => ele?.heading == "Recruitment-Form About"
  )?.description;

  const [RecruitmentData, setRecruitmentData] = useState(emptyData);
  const [loader, setLoader] = useState(false);

  const fillRecruitmentData = (name, val) => {
    setRecruitmentData((old) => {
      return { ...old, [name]: val };
    });
  };

  const createRecruitment = async (e) => {
    setLoader(true);
    let check = false;
    if (
      RecruitmentData.fullName == "" ||
      RecruitmentData.contactNo == "" ||
      RecruitmentData.postApplied == "" ||
      RecruitmentData.highestQualification == "" ||
      RecruitmentData.file == "" ||
      RecruitmentData.email == ""
    ) {
      toast.error("Please Fill All The Fields");
      setLoader(false);
      check = true;
    }
    if (check) {
      return;
    }
    try {
      const responseSubmit = await postRecruitment(RecruitmentData);
      if (responseSubmit.ack == 1) {
        toast.success("Successfully Submitted..");
        setRecruitmentData({ ...emptyData });

        recruitmentRef.current.value = "";
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  async function uploadPdfFile(e) {
    setLoader(true);
    const type = "resume";
    const res = await uploadFile(e, RecruitmentData.fullName, type);
    setRecruitmentData((old) => ({ ...old, file: res }));
    setLoader(false);
  }
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="content-box">
            <div className="content-wrapper">
              <div className="title">
                <h1>Recruitment</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="career-bg">
        <div className="container">
          <div className="row">
            <div className="school-main-title">
              <div className="school-heading-subheading center-align text-center">
                <h2 className="school-title">Recruitment From</h2>
                <div className="school-heading-desc">
                  {RecruitmentAbout?.includes("<p>") ||
                  RecruitmentAbout?.includes("<h1>") ||
                  RecruitmentAbout?.includes("<h2>") ||
                  RecruitmentAbout?.includes("<h3>")
                    ? ReactHtmlParser(RecruitmentAbout)
                    : RecruitmentAbout
                    ? RecruitmentAbout
                    : helperText.slice(0, 30)}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="sm-12">
              <div className="form-inner">
                <div className="row mb-3 g-3">
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Full Name"
                      name="fullName"
                      value={RecruitmentData?.fullName}
                      onChange={(e) =>
                        fillRecruitmentData(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Contact No</label>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control"
                      placeholder="Enter Your Contact No"
                      name="contactNo"
                      value={RecruitmentData?.contactNo}
                      onChange={(e) =>
                        fillRecruitmentData(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={RecruitmentData?.email}
                      placeholder="Enter Your Email"
                      name="email"
                      onChange={(e) =>
                        fillRecruitmentData(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Highest Qualification</label>
                    <input
                      type="text"
                      className="form-control"
                      value={RecruitmentData?.highestQualification}
                      placeholder="Enter Your Highest Qualification"
                      name="highestQualification"
                      onChange={(e) =>
                        fillRecruitmentData(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Post Applied For</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Post"
                      name="postApplied"
                      value={RecruitmentData?.postApplied}
                      onChange={(e) =>
                        fillRecruitmentData(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="col-lg-4 md-6">
                    <label className="mb-2">Upload Your CV</label>
                    <input
                      ref={recruitmentRef}
                      type="file"
                      className="form-control"
                      name="file"
                      accept=".pdf"
                      onChange={(e) => uploadPdfFile(e)}
                    />
                    <small>note*: Only .pdf is supported</small>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-12 text-center mt-4">
                    <button
                      disabled={loader}
                      className="theme-btn btn-style-one text-center"
                      type="submit"
                      onClick={(e) => createRecruitment(e)}
                    >
                      {loader ? (
                        <div class="spinner-border text-dark" role="status">
                          <span class="sr-only"></span>
                        </div>
                      ) : (
                        <>
                          <span>Submit</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recruitment;
